/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface EIIResponseDTO
 */
export interface EIIResponseDTOOptional {
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  workingAdults?: number;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  nonWorkingAdults?: number;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  children?: number;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  householdIncome?: number;
}

export interface EIIResponseDTO extends EIIResponseDTOOptional {
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  workingAdults: number;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  nonWorkingAdults: number;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  children: number;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  householdIncome: number;
}

export interface EIIResponseDTOTrackedI {
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  workingAdults?: number;
  workingAdultsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  nonWorkingAdults?: number;
  nonWorkingAdultsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  children?: number;
  childrenIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof EIIResponseDTO
   */
  householdIncome?: number;
  householdIncomeIsSet: boolean;
}

transformDatesMap.set("EIIResponseDTO", function (model: EIIResponseDTO) {});

export type EIIResponseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  workingAdults: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  nonWorkingAdults: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  children: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  householdIncome: PropertyMeta<MetaTypeBase<number>>;
}>;

export var EIIResponseDTOMeta: EIIResponseDTOMetaI = {} as EIIResponseDTOMetaI;
EIIResponseDTOMeta = typeMeta("EIIResponseDTO", {
  workingAdults: propertyMeta(
    "workingAdults",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  nonWorkingAdults: propertyMeta(
    "nonWorkingAdults",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  children: propertyMeta("children", false, true, false, MetaTypesBase.number),
  householdIncome: propertyMeta(
    "householdIncome",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = EIIResponseDTOMeta;

registerMeta(() => {});

export class EIIResponseDTOTracked implements EIIResponseDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  workingAdults__I?: number = undefined;
  workingAdultsIsSet: boolean = false;
  set workingAdults(v: undefined | number) {
    if (v !== undefined) {
      this.workingAdults__I = v;
      this.workingAdultsIsSet = true;
    } else {
      this.workingAdults__I = v || undefined;
      this.workingAdultsIsSet = true;
    }
    this.changeTracker = true;
  }
  get workingAdults() {
    return this.workingAdults__I;
  }
  nonWorkingAdults__I?: number = undefined;
  nonWorkingAdultsIsSet: boolean = false;
  set nonWorkingAdults(v: undefined | number) {
    if (v !== undefined) {
      this.nonWorkingAdults__I = v;
      this.nonWorkingAdultsIsSet = true;
    } else {
      this.nonWorkingAdults__I = v || undefined;
      this.nonWorkingAdultsIsSet = true;
    }
    this.changeTracker = true;
  }
  get nonWorkingAdults() {
    return this.nonWorkingAdults__I;
  }
  children__I?: number = undefined;
  childrenIsSet: boolean = false;
  set children(v: undefined | number) {
    if (v !== undefined) {
      this.children__I = v;
      this.childrenIsSet = true;
    } else {
      this.children__I = v || undefined;
      this.childrenIsSet = true;
    }
    this.changeTracker = true;
  }
  get children() {
    return this.children__I;
  }
  householdIncome__I?: number = undefined;
  householdIncomeIsSet: boolean = false;
  set householdIncome(v: undefined | number) {
    if (v !== undefined) {
      this.householdIncome__I = v;
      this.householdIncomeIsSet = true;
    } else {
      this.householdIncome__I = v || undefined;
      this.householdIncomeIsSet = true;
    }
    this.changeTracker = true;
  }
  get householdIncome() {
    return this.householdIncome__I;
  }
  constructor(config?: EIIResponseDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: EIIResponseDTOOptional,
    options?: AssignOptions,
  ): EIIResponseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.workingAdults &&
      this.workingAdultsApplyFilter(optionsRequired.filter)
    ) {
      this.workingAdults = config.workingAdults;
      if (optionsRequired.unassign) this.workingAdultsIsSet = false;
      else this.workingAdultsIsSet = true;
    }
    if (
      config.nonWorkingAdults &&
      this.nonWorkingAdultsApplyFilter(optionsRequired.filter)
    ) {
      this.nonWorkingAdults = config.nonWorkingAdults;
      if (optionsRequired.unassign) this.nonWorkingAdultsIsSet = false;
      else this.nonWorkingAdultsIsSet = true;
    }
    if (config.children && this.childrenApplyFilter(optionsRequired.filter)) {
      this.children = config.children;
      if (optionsRequired.unassign) this.childrenIsSet = false;
      else this.childrenIsSet = true;
    }
    if (
      config.householdIncome &&
      this.householdIncomeApplyFilter(optionsRequired.filter)
    ) {
      this.householdIncome = config.householdIncome;
      if (optionsRequired.unassign) this.householdIncomeIsSet = false;
      else this.householdIncomeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EIIResponseDTOTrackedI {
    const cloned = {} as EIIResponseDTOTrackedI;
    if (
      this.workingAdultsIsSetDeep() &&
      this.workingAdultsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.workingAdultsIsSet = true;
      cloned.workingAdults = this.workingAdults;
    } else {
      //cloned.workingAdultsIsSet = false
    }
    if (
      this.nonWorkingAdultsIsSetDeep() &&
      this.nonWorkingAdultsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nonWorkingAdultsIsSet = true;
      cloned.nonWorkingAdults = this.nonWorkingAdults;
    } else {
      //cloned.nonWorkingAdultsIsSet = false
    }
    if (
      this.childrenIsSetDeep() &&
      this.childrenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childrenIsSet = true;
      cloned.children = this.children;
    } else {
      //cloned.childrenIsSet = false
    }
    if (
      this.householdIncomeIsSetDeep() &&
      this.householdIncomeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.householdIncomeIsSet = true;
      cloned.householdIncome = this.householdIncome;
    } else {
      //cloned.householdIncomeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EIIResponseDTOTrackedI {
    if (!this.workingAdultsApplyFilter(filter)) this.workingAdultsIsSet = false;

    if (!this.nonWorkingAdultsApplyFilter(filter))
      this.nonWorkingAdultsIsSet = false;

    if (!this.childrenApplyFilter(filter)) this.childrenIsSet = false;

    if (!this.householdIncomeApplyFilter(filter))
      this.householdIncomeIsSet = false;

    return this;
  }
  workingAdultsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EIIResponseDTOMeta.workingAdults,
      EIIResponseDTOMeta,
      this.workingAdults,
      this,
    );
  }
  workingAdultsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.workingAdultsIsSet && this.workingAdultsApplyFilter(filter))
      return true;

    return false;
  }
  nonWorkingAdultsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EIIResponseDTOMeta.nonWorkingAdults,
      EIIResponseDTOMeta,
      this.nonWorkingAdults,
      this,
    );
  }
  nonWorkingAdultsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nonWorkingAdultsIsSet && this.nonWorkingAdultsApplyFilter(filter))
      return true;

    return false;
  }
  childrenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EIIResponseDTOMeta.children,
      EIIResponseDTOMeta,
      this.children,
      this,
    );
  }
  childrenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childrenIsSet && this.childrenApplyFilter(filter)) return true;

    return false;
  }
  householdIncomeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EIIResponseDTOMeta.householdIncome,
      EIIResponseDTOMeta,
      this.householdIncome,
      this,
    );
  }
  householdIncomeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.householdIncomeIsSet && this.householdIncomeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.workingAdultsIsSetDeep(filter)) return true;
    if (this.nonWorkingAdultsIsSetDeep(filter)) return true;
    if (this.childrenIsSetDeep(filter)) return true;
    if (this.householdIncomeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
